<script>
  import { format } from 'svelte-i18n';
  import { Button } from '@sveltestrap/sveltestrap';

  import { Clipboard } from '@client/components/clipboard';
  import { Icon } from '@client/components/icon';

  export let badge = null;
  export let editing = false;
  export let readonly = false;
  export let disableSubmit = true;
  export let showActions = true;
  export let editLabel = 'label.EDIT';
  export let cancelLabel = 'label.CANCEL';
  export let saveLabel = 'label.SAVE';
  export let copyLabel = 'label.COPY';
  export let copyValue = null;
  export let allowCopy = false;
  export let onCancel = null;
  export let onEdit = null;
  export let onSave = null;

  let copying = false;

  const copyText = (copyFn) => {
    copying = true;
    copyFn(copyValue);

    setTimeout(() => {
      copying = false;
    }, 1000);
  };
</script>

{#if showActions}
  <div class="field-actions">
    {#if badge}
      {@html badge}
    {/if}

    {#if !readonly}
      {#if !editing}
        {#if allowCopy}
          <Clipboard text={copyValue} let:copy>
            <Button color="secondary" size="sm" class="copy" tabindex="0" on:click={() => copyText(copy)}>
              {#if copying}
                <Icon name="check" />
              {:else}
                <Icon name="copy" />
              {/if}

              {$format(copyLabel)}
            </Button>
          </Clipboard>
        {/if}
        <button class="edit" tabindex="0" on:click={onEdit}>{$format(editLabel)}</button>
      {:else}
        <button class="cancel" tabindex="0" on:click={onCancel}>{$format(cancelLabel)}</button>
        <Button color="primary" size="sm" disabled={disableSubmit} on:click={onSave}>{$format(saveLabel)}</Button>
      {/if}
    {/if}
  </div>
{:else}
  <div class="field-actions">
    {#if !readonly}
      {#if !editing}
        {#if allowCopy}
          <Clipboard text={copyValue} let:copy>
            <Button color="secondary" size="sm" class="copy" tabindex="0" on:click={() => copyText(copy)}>
              {#if copying}
                <Icon name="check" />
              {:else}
                <Icon name="copy" />
              {/if}

              {$format(copyLabel)}
            </Button>
          </Clipboard>
        {/if}
      {/if}
    {/if}
  </div>
{/if}

<style lang="scss" src="./actions.scss"></style>
